<div class="login-page-container">
  <div class="wrapper-login">
    <div class="wrapper-title">
      <span class="title-welcome">{{ "login.welcome.title" | translate }}</span>
      <div class="wrapper-title-subtitle">
        @if (mode === "default") {
          <span class="login-title-single-line">{{
            "login.welcome.subtitleFirstLine" | translate
          }}</span>
          <span>{{ "login.welcome.subtitleSecondLine" | translate }}</span>
        } @else {
          <span class="login-title-single-line">{{
            "al formulari de càrrega de dades manual" | translate
          }}</span>
        }
      </div>
    </div>
    <div class="wrapper-form-login">
      <span class="title-form">{{
        "login.wrapperLogin.loginSession" | translate
      }}</span>
      <div class="fixed-container">
        <div>
          <ng-gencat-form
            (loaded)="loginPoolsFormLoaded($event)"
            [controls]="loginFormConfigSignal()"
          />
          @let shouldShowForgotPassword = showForgotPasswordLinkSignal();
          @if (shouldShowForgotPassword) {
            <div class="login-forgot-password-link-wrapper">
              <span
                class="login-forgot-password-link"
                (click)="redirectToForgotPassword()"
                >{{ "login.forgotPassword" | translate }}</span
              >
            </div>
          }

          <div class="poolRedirectButtonWrapper">
            <button-component
              text="login.button"
              customId="pool_redirect_button"
              [tmobBtnStyle]="primaryButton"
              [appButtonDisable]="!readyLoginSignal()"
              (click)="login()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="wrapper-image"><div class="image-login-background"></div></div>
</div>
